import React, { Component } from 'react'
import _reduce from 'lodash/reduce'
import _map from 'lodash/map'
import _get from 'lodash/get'
import CampaignIconLink from '../CampaignIconLink'
import makeDisplay from './helpers'
import { IGNORED_ATTRIBUTES } from './constants'
import styles from './style.styl'

function getScoreClass(score) {
  if (score > 8) return 'promoter'
  if (score <= 6) return 'detractor'
  return 'passive'
}

export default class EventData extends Component {

  getAttributeSource = () => {
    const { event } = this.props
    if (event.eventType === 'PROPERTY') {
      return _get(this.props, 'event.body', {})
    }
    return _get(this.props, 'event.body.attributes', {})
  }

  filterAttributes = () => {
    const attributes = this.getAttributeSource()
    return _reduce(attributes, (attrs, attr, key) => {
      if (!IGNORED_ATTRIBUTES.includes(key)){
        attrs[key] = attr
      }
      return attrs
    }, {})
  }

  renderNPSResponse = () => {
    const { textResponse, numericResponse } = this.props.event.body
    return (
      <div className="color-navy-dark flex">
          <span className={`dsg-medium-weight ${styles.NPSEvent} ${getScoreClass(numericResponse)}`}>
            {numericResponse}
          </span>
          {textResponse
            ? <div className="dsg-Body">&ldquo;{textResponse}&rdquo;</div>
            : null}
      </div>
    )
  }

  renderNote = () => (
    <div
      className={`dsg-Body ${styles.NoteBody}`}
      dangerouslySetInnerHTML={{ __html: this.props.event.body.note.body }}
    />
  )

  renderAttributes = () => {
    const allowedAttributes = this.filterAttributes()
    if (_.isEmpty(allowedAttributes))
      return
    const attrList = _map(allowedAttributes, this.renderAttr)
    return (
      <ul>{attrList}</ul>
    )
  }

  renderCode = (val) => (
    <code>{JSON.stringify(val)}</code>
  )

  renderAttr = (val, key) => {
    return (
      <li key={key}>
        <span className="attributeKey">{key}</span>:
        <span className="attributeValue">
          {typeof val === 'string' ? val : this.renderCode(val)}
        </span>
      </li>
    )
  }

  renderCampaign = () => {
    const { author, campaign } = this.props
    return (
      <span>
        {makeDisplay(author, this.props.endUser, this.props.event.createdAt)}
        <CampaignIconLink campaign={campaign}/>
      </span>
    )
  }

  render() {
    const { isNote, campaign } = this.props
    const numericResponse = _get(this.props, 'event.body.numericResponse')
    return (
      <div className={styles.TimelineAttributes}>
        {isNote && this.renderNote()}
        {campaign && this.renderCampaign()}
        {numericResponse && this.renderNPSResponse()}
        {this.renderAttributes()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/EventData/index.js